/**
 * Mapping of blanket configuration enum values to their display text
 * This ensures consistency between dropdown options and display values
 */
export const BLANKET_DISPLAY_TEXT = {
  // First Wall Type
  'TUNGSTEN': 'Tungsten',
  'LIQUID_LITHIUM': 'Liquid Lithium',
  'BERYLLIUM': 'Beryllium',
  'FLIBE': 'FLiBe',
  
  // Blanket Type
  'FLOWING_LIQUID_FIRST_WALL': 'Flowing Liquid First Wall',
  'SOLID_FIRST_WALL_WITH_A_LIQUID_BREEDER': 'Solid First Wall with a Liquid Breeder',
  'SOLID_FIRST_WALL_WITH_A_SOLID_BREEDER_LI4SIO4': 'Solid First Wall with Solid Breeder (Li4SiO4)',
  'SOLID_FIRST_WALL_WITH_A_SOLID_BREEDER_LI2TIO3': 'Solid First Wall with Solid Breeder (Li2TiO3)',
  'SOLID_FIRST_WALL_NO_BREEDER_ANEUTRONIC_FUEL': 'Solid First Wall No Breeder (Aneutronic Fuel)',
  
  // Coolant Types (Primary and Secondary)
  'LEAD_LITHIUM_PBLI': 'Lead Lithium (PbLi)',
  'LITHIUM_LI': 'Lithium (Li)',
  'OTHER_EUTECTIC_SALT': 'Other Eutectic Salt',
  'HELIUM': 'Helium (He)',
  'DUAL_COOLANT_PBLI_AND_HE': 'Dual Coolant: PbLi and He',
  'WATER': 'Water',
  'NONE': 'None',
  
  // Neutron Multiplier
  'BE': 'Beryllium (Be)',
  'PB': 'Lead (Pb)',
  'PB_AS_PART_OF_PBLI': 'Pb as part of PbLi',
  'BE12TI': 'Beryllium Titanium (Be12Ti)',
  
  // Structural Material
  'STAINLESS_STEEL_SS': 'Stainless Steel (SS)',
  'FERRITIC_MARTENSITIC_STEEL_FMS': 'Ferritic Martensitic Steel (FMS)',
  'OXIDE_DISPERSION_STRENGTHENED_ODS_STEEL': 'Oxide Dispersion Strengthened Steel (ODS)',
  'VANADIUM': 'Vanadium',
};

/**
 * Get display text for a blanket enum value
 * @param {string} value - The enum value
 * @returns {string} - The display text, or the original value if not found
 */
export const getBlanketDisplayText = (value) => {
  if (!value || value === '') return 'Not set';
  return BLANKET_DISPLAY_TEXT[value] || value;
};

/**
 * Option groups for dropdowns
 */
export const FIRST_WALL_TYPE_OPTIONS = [
  { value: 'TUNGSTEN', display: BLANKET_DISPLAY_TEXT.TUNGSTEN },
  { value: 'LIQUID_LITHIUM', display: BLANKET_DISPLAY_TEXT.LIQUID_LITHIUM },
  { value: 'BERYLLIUM', display: BLANKET_DISPLAY_TEXT.BERYLLIUM },
  { value: 'FLIBE', display: BLANKET_DISPLAY_TEXT.FLIBE },
];

export const BLANKET_TYPE_OPTIONS = [
  { value: 'FLOWING_LIQUID_FIRST_WALL', display: BLANKET_DISPLAY_TEXT.FLOWING_LIQUID_FIRST_WALL },
  { value: 'SOLID_FIRST_WALL_WITH_A_LIQUID_BREEDER', display: BLANKET_DISPLAY_TEXT.SOLID_FIRST_WALL_WITH_A_LIQUID_BREEDER },
  { value: 'SOLID_FIRST_WALL_WITH_A_SOLID_BREEDER_LI4SIO4', display: BLANKET_DISPLAY_TEXT.SOLID_FIRST_WALL_WITH_A_SOLID_BREEDER_LI4SIO4 },
  { value: 'SOLID_FIRST_WALL_WITH_A_SOLID_BREEDER_LI2TIO3', display: BLANKET_DISPLAY_TEXT.SOLID_FIRST_WALL_WITH_A_SOLID_BREEDER_LI2TIO3 },
  { value: 'SOLID_FIRST_WALL_NO_BREEDER_ANEUTRONIC_FUEL', display: BLANKET_DISPLAY_TEXT.SOLID_FIRST_WALL_NO_BREEDER_ANEUTRONIC_FUEL },
];

export const COOLANT_TYPE_OPTIONS = [
  { value: 'LEAD_LITHIUM_PBLI', display: BLANKET_DISPLAY_TEXT.LEAD_LITHIUM_PBLI },
  { value: 'LITHIUM_LI', display: BLANKET_DISPLAY_TEXT.LITHIUM_LI },
  { value: 'FLIBE', display: BLANKET_DISPLAY_TEXT.FLIBE },
  { value: 'OTHER_EUTECTIC_SALT', display: BLANKET_DISPLAY_TEXT.OTHER_EUTECTIC_SALT },
  { value: 'HELIUM', display: BLANKET_DISPLAY_TEXT.HELIUM },
  { value: 'DUAL_COOLANT_PBLI_AND_HE', display: BLANKET_DISPLAY_TEXT.DUAL_COOLANT_PBLI_AND_HE },
  { value: 'WATER', display: BLANKET_DISPLAY_TEXT.WATER },
];

export const SECONDARY_COOLANT_TYPE_OPTIONS = [
  { value: 'NONE', display: BLANKET_DISPLAY_TEXT.NONE },
  ...COOLANT_TYPE_OPTIONS,
];

export const NEUTRON_MULTIPLIER_OPTIONS = [
  { value: 'NONE', display: BLANKET_DISPLAY_TEXT.NONE },
  { value: 'BE', display: BLANKET_DISPLAY_TEXT.BE },
  { value: 'PB', display: BLANKET_DISPLAY_TEXT.PB },
  { value: 'PB_AS_PART_OF_PBLI', display: BLANKET_DISPLAY_TEXT.PB_AS_PART_OF_PBLI },
  { value: 'BE12TI', display: BLANKET_DISPLAY_TEXT.BE12TI },
];

export const STRUCTURAL_MATERIAL_OPTIONS = [
  { value: 'STAINLESS_STEEL_SS', display: BLANKET_DISPLAY_TEXT.STAINLESS_STEEL_SS },
  { value: 'FERRITIC_MARTENSITIC_STEEL_FMS', display: BLANKET_DISPLAY_TEXT.FERRITIC_MARTENSITIC_STEEL_FMS },
  { value: 'OXIDE_DISPERSION_STRENGTHENED_ODS_STEEL', display: BLANKET_DISPLAY_TEXT.OXIDE_DISPERSION_STRENGTHENED_ODS_STEEL },
  { value: 'VANADIUM', display: BLANKET_DISPLAY_TEXT.VANADIUM },
];
